import React from 'react';
import './Pagination.css';

function Pagination({ currentPage, totalPages, onPageChange }) {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
            pageNumbers.push(i);
        } else if ((i === currentPage - 3 || i === currentPage + 3) && totalPages > 1) {
            pageNumbers.push('...');
        }
    }

    const renderPageNumbers = pageNumbers.map((number, index) => (
        <li key={index} className={`page-item ${currentPage === number ? 'active' : ''} ${number === '...' ? 'disabled' : ''}`}>
            {number === '...' ? (
                <span className="page-link">...</span>
            ) : (
                <button onClick={() => onPageChange(number)} className="page-link">
                    {number}
                </button>
            )}
        </li>
    ));

    return (
        <nav>
            <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button onClick={() => currentPage > 1 && onPageChange(currentPage - 1)} className="page-link" disabled={currentPage === 1}>
                        &lt;
                    </button>
                </li>
                {renderPageNumbers}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)} className="page-link" disabled={currentPage === totalPages}>
                        &gt;
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default Pagination;

